<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">{{ title | translate }}</h4>
  </div>
  <div class="modal-body" style="{{customStyleModal}}">
    <div class="row">
      <div class="col-md-1 cw-100">
        <i class="{{iconClass}}"></i>
      </div>
      <div class="col-md-11">
        <div class="pl-2" [innerHTML]="message"></div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" data-dismiss="alert" aria-label="Close"  class="btn btn-outline-{{informCodeDesc}}"
            (click)="accept()">{{ "BUTTON.ACCEPT" | translate }}</button>
  </div>
</div>

